import { tauri_proxy_http, tauri_system_os } from './tauri';
import { HttpConverter } from 'convert-axios-http';
import { AxiosHeaders, RawAxiosRequestHeaders, AxiosRequestHeaders, AxiosRequestConfig, AxiosError, InternalAxiosRequestConfig } from "axios";

let converter = new HttpConverter();

export default (config: AxiosRequestConfig) => {
  return new Promise((resolve, reject) => {
    converter.axiosRequestToHttpBytes(config).then((httpBytes: ArrayBuffer) => {
      tauri_proxy_http(httpBytes).then((responseBytes: ArrayBuffer) => {

        let response = converter.httpBytesToAxiosResponse(responseBytes);

        config.headers = normalizeAxiosRequestHeaders(config.headers);
        response.config = config as InternalAxiosRequestConfig;

        if (response.status < 300) {
          return resolve(response);
        }
        else {
          let err = new AxiosError(
            'Request failed with status code ' + response.status,
            [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
            response.config,
            config,
            response
          );
          return reject(err);
        }
      });
    });
  });
};

/**
 * Normalize headers so they’re always AxiosHeaders.
 */
function normalizeAxiosRequestHeaders(
  headers?: RawAxiosRequestHeaders | AxiosHeaders
): AxiosRequestHeaders {
  if (!headers) {
    return new AxiosHeaders(); // empty
  }
  // If it's already an AxiosHeaders, just return as-is
  if (headers instanceof AxiosHeaders) {
    return headers as AxiosRequestHeaders;
  }
  // Otherwise, convert to AxiosHeaders
  return AxiosHeaders.from(headers as any);
}
